import React, { createContext } from 'react';

const baseContext = {
  setModalContent: (content: ModalContent) => {},
  setToastContent: (content: ToastContent) => {},
};

export const initialModalContent: ModalContent = {
  title: '',
  modalContent: React.createElement('div'),
  submitButtonTitle: '',
  submitButtonType: '',
  submitData: {},
  onSubmitButtonClick: Promise.resolve(),
  onCloseModal: Promise.resolve(),
  isOpen: false,
};

export const initialToastContent: ToastContent = {
  type: null,
  text: '',
  isOpen: false,
};

export const GeneralContext = createContext(baseContext);
